import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import BusyType from 'owa-service/lib/contract/BusyType';
import { action } from 'satcheljs';
import { CharmSelectionType, ComposeFormType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';

// This file contains the actions that are used by the orchestrators.
// The actions here won't be usually called by view since they don't cause the  necessary side effects

/**
 * Action called to update the subject
 */
export const updateSubject = action('updateSubject', (subject: string) => ({ subject }));

/**
 * Action called to update the charm selection state
 * TODO: This will be removed when full compose switches to using charmSelectionType instead of explicitlySet
 */
export const updateCharmSelection = action('updateCharmSelection', (explicitlySet: boolean) => ({
    explicitlySet: explicitlySet,
}));

/**
 * Action called to update the charm selection type
 */
export const updateCharmSelectionType = action(
    'updateCharmSelectionType',
    (charmSelectionType: CharmSelectionType) => ({
        charmSelectionType: charmSelectionType,
    })
);

/**
 * Action called to update the charm and charm selection type
 */
export const updateCharmAndSelectionType = action(
    'updateCharmAndSelectionType',
    (iconId: number, charmSelection: CharmSelectionType) => ({
        iconId: iconId,
        charmSelection: charmSelection,
    })
);

/**
 * Action called to change the opened form in compose
 */
export const updateOpenedForm = action('updateOpenedForm', (openedForm: ComposeFormType) => ({
    openedForm: openedForm,
}));

/**
 * Action called to update the charm
 */
export const updateCharm = action('updateCharm', (iconId: number) => ({ iconId: iconId }));

/**
 * Action called to update the busy status property in the store
 */
export const updateFreeBusy = action('updateFreeBusy', (busyType: BusyType) => ({
    busyType: busyType,
}));

/**
 * Action called to update the isUndoNotificationShown value
 */
export const updateIsUndoNotificationShown = action(
    'updateIsUndoNotificationShown',
    (isUndoNotificationShown: boolean) => ({
        isUndoNotificationShown,
    })
);

/**
 * Action called to update the dates
 */
export const updateDateTimes = action(
    'updateDateTimes ',
    (datesSelected: OwaDateRange, timeChangeActionType?: TimeChangeActionType) => ({
        datesSelected,
        timeChangeActionType,
    })
);

/**
 * Action called to update the all day flag
 */
export const updateAllDay = action(
    'updateAllDay',
    (isAllDayEvent: boolean, isAllDayEventExplicitlySet: boolean = false) => ({
        isAllDayEvent,
        isAllDayEventExplicitlySet,
    })
);

/**
 * Action called to add a persona to the required attendees list
 */
export const addPersonaToRequiredAttendees = action(
    'addPersonaToRequiredAttendees',
    (persona: FindRecipientPersonaType) => ({
        persona,
    })
);

export const addAttendeeFromEmailAddress = action(
    'addAttendeeFromEmailAddress',
    (emailAddress: string) => ({
        emailAddress,
    })
);

/**
 * Action called to remove a persona from the required attendees list
 */
export const removePersonaFromRequiredAttendees = action(
    'removePersonaFromRequiredAttendees',
    (persona: FindRecipientPersonaType) => ({
        persona,
    })
);

/**
 * Action called to update required attendees
 */
export const updateRequiredAttendees = action(
    'updateRequiredAttendees ',
    (requiredAttendees: AttendeeType[]) => ({
        requiredAttendees: requiredAttendees,
    })
);

/**
 * Action called to update optional attendees
 */
export const updateOptionalAttendees = action(
    'updateOptionalAttendees ',
    (optionalAttendees: AttendeeType[]) => ({ optionalAttendees: optionalAttendees })
);

/**
 * Action called to update resources
 */
export const updateResources = action('updateResources', (resources: AttendeeType[]) => ({
    resources: resources,
}));
